import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';

import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm$indicators$data, _this$indicators;
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "content-centered large"
  }, [_vm.init.isLoading ? _c("div", {
    staticClass: "text-xl text-center"
  }, [_vm._v(" We're performing security checks to ensure secure access to your dashboard. ")]) : !_vm.wineryDashboard || !_vm.isAuthorized ? _c("div", {
    staticClass: "text-xl text-center"
  }, [_c("div", [_vm._v("An error occurred accessing your dashboard.")]), _c("div", [_vm._v(" Please "), _c("router-link", {
    attrs: {
      to: _vm.routeToContact()
    }
  }, [_vm._v("contact us")]), _vm._v(" if you encounter any issue. ")], 1)]) : !_vm.visit.data && !_vm.isAdminNotConsultant(_vm.loggedUserData) ? [_c("div", {
    staticClass: "container-centered small-3"
  }, [_c("div", {
    staticClass: "flex flex-column items-stretch justify-start text-left"
  }, [_c("div", [_vm._v("Please enter your name")]), _c(VForm, {
    staticClass: "dfwa-form",
    model: {
      value: _vm.visit.form.valid,
      callback: function callback($$v) {
        _vm.$set(_vm.visit.form, "valid", $$v);
      },
      expression: "visit.form.valid"
    }
  }, [_c(VTextField, {
    staticClass: "v-text-field-no-label",
    attrs: {
      maxlength: 200,
      placeholder: "Your name",
      required: "",
      rules: [_vm.formRules.mustNotBeEmpty],
      "hide-details": "auto",
      autofocus: ""
    },
    model: {
      value: _vm.visit.form.name,
      callback: function callback($$v) {
        _vm.$set(_vm.visit.form, "name", $$v);
      },
      expression: "visit.form.name"
    }
  })], 1), _c("div", {
    staticClass: "text-center mt-default"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small --with-dark-bg",
    attrs: {
      rounded: "",
      disabled: !_vm.visit.form.valid,
      loading: _vm.visit.isCreating
    },
    on: {
      click: function click($event) {
        return _vm.createVisit();
      }
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-chart-line mr-2",
    attrs: {
      size: "0.85rem"
    }
  }), _vm._v(" Access to my dashboard ")], 1)], 1)], 1)])] : [_c("div", {
    staticStyle: {
      "font-size": "1.5rem"
    }
  }, [_vm._v(" " + _vm._s(_vm.wineryDashboard.title) + " ")]), _c("div", {
    staticClass: "mt-default"
  }, [_c("div", {
    staticClass: "text-smaller text-italic"
  }, [_vm._v("From date is included, to date is not included")]), _c("div", {
    staticClass: "form-date-line-search"
  }, [_c("div", {
    staticClass: "form-date-line-search-dates"
  }, [_c("div", [_c("span", [_vm._v("From")]), _c("date-picker", {
    staticClass: "on-public-dashboard",
    attrs: {
      clearable: false,
      valueType: "format"
    },
    model: {
      value: _vm.indicators.form.dateStart,
      callback: function callback($$v) {
        _vm.$set(_vm.indicators.form, "dateStart", $$v);
      },
      expression: "indicators.form.dateStart"
    }
  })], 1), _c("div", [_c("span", [_vm._v("to")]), _c("date-picker", {
    staticClass: "on-public-dashboard",
    attrs: {
      clearable: false,
      valueType: "format"
    },
    model: {
      value: _vm.indicators.form.dateEnd,
      callback: function callback($$v) {
        _vm.$set(_vm.indicators.form, "dateEnd", $$v);
      },
      expression: "indicators.form.dateEnd"
    }
  })], 1)])])]), _c("div", {
    staticClass: "mt-4 no-print"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small --with-dark-bg",
    attrs: {
      rounded: true,
      loading: _vm.indicators.isGenerating
    },
    on: {
      click: function click($event) {
        return _vm.searchIndicators();
      }
    }
  }, [_vm._v(" Generate dashboard ")]), _c(VBtn, {
    staticClass: "dfwa-btn --small --with-dark-bg",
    attrs: {
      rounded: true,
      loading: _vm.indicators.isExporting
    },
    on: {
      click: function click($event) {
        return _vm.exportIndicators();
      }
    }
  }, [_vm._v(" Export as excel file ")])], 1), _vm.indicators.isGenerating ? _c("div", {
    staticClass: "mt-4 text-smaller text-italic"
  }, [_vm._v(" We are creating your dashboard, please wait a moment. ")]) : _vm._e(), !!_vm.indicators.data && ((_vm$indicators$data = _vm.indicators.data) === null || _vm$indicators$data === void 0 ? void 0 : _vm$indicators$data.nbOrders) < 1 ? _c("div", {
    staticClass: "mt-4"
  }, [_vm._v(" No sales available for this period. ")]) : _vm._e(), _vm.indicators.isLoaded ? _c("div", {
    staticClass: "mt-3 flex justify-center no-print"
  }, [_c("div", {
    staticClass: "display-switch"
  }, [_c("span", {
    class: !_vm.indicators.detailedView.isShown ? "text-bold" : ""
  }, [_vm._v("Only graphics")]), _c(VSwitch, {
    staticClass: "mt-0",
    attrs: {
      "hide-details": "auto"
    },
    model: {
      value: _vm.indicators.detailedView.isShown,
      callback: function callback($$v) {
        _vm.$set(_vm.indicators.detailedView, "isShown", $$v);
      },
      expression: "indicators.detailedView.isShown"
    }
  }), _c("span", {
    class: _vm.indicators.detailedView.isShown ? "text-bold" : ""
  }, [_vm._v("Add tables")])], 1)]) : _vm._e(), _c("div", {
    staticClass: "indicators-global-container --dark-bg"
  }, [_vm.indicators.isLoaded ? _c("div", {
    class: ["indicators-mains", !_vm.isShowTurnover ? "--2cols" : ""]
  }, [_c("div", {
    staticClass: "indicators-mains-item"
  }, [_c("i", {
    staticClass: "fas fa-wine-bottle"
  }), _c("div", {
    staticClass: "indicators-mains-item-title"
  }, [_vm._v("Volume delivered")]), _c("div", {
    staticClass: "indicators-mains-item-datas"
  }, [_c("div", {
    staticClass: "indicators-mains-item-datas-main"
  }, [_vm._v(" " + _vm._s(_vm.indicators.data.totalQuantity) + " bottles ")])])]), _c("div", {
    staticClass: "indicators-mains-item"
  }, [_c("i", {
    staticClass: "fas fa-shopping-cart"
  }), _c("div", {
    staticClass: "indicators-mains-item-title"
  }, [_vm._v("Orders delivered")]), _c("div", {
    staticClass: "indicators-mains-item-datas"
  }, [_c("div", {
    staticClass: "indicators-mains-item-datas-main"
  }, [_vm._v(" " + _vm._s(_vm.indicators.data.nbOrders) + " ")])])]), _vm.isShowTurnover ? _c("div", {
    staticClass: "indicators-mains-item"
  }, [_c("i", {
    staticClass: "fas fa-hand-holding-usd"
  }), _c("div", {
    staticClass: "indicators-mains-item-title"
  }, [_vm._v("Turnover")]), _c("div", {
    staticClass: "indicators-mains-item-datas"
  }, [_c("div", {
    staticClass: "indicators-mains-item-datas-main"
  }, [_vm._v(" " + _vm._s(_vm.formatPrice(_vm.indicators.data.totalTurnoverExVatEuro)) + " € ")])])]) : _vm._e()]) : _vm._e(), _c("div", {
    staticClass: "indicators-charts"
  }, [_c("div", {
    staticClass: "indicators-charts-item",
    class: {
      loaded: _vm.indicators.isLoaded
    }
  }, [_c("div", {
    staticClass: "indicators-charts-item-title"
  }, [_vm._v("Destinations")]), _c(VTabs, {
    attrs: {
      centered: ""
    },
    model: {
      value: _vm.indicators.destinations.tab,
      callback: function callback($$v) {
        _vm.$set(_vm.indicators.destinations, "tab", $$v);
      },
      expression: "indicators.destinations.tab"
    }
  }, [_c(VTab, {
    key: 1
  }, [_vm._v("Volume (btl)")]), _c(VTab, {
    key: 2
  }, [_vm._v("Orders")]), _vm.isShowTurnover ? _c(VTab, {
    key: 3
  }, [_vm._v("Turnover (€)")]) : _vm._e()], 1), _c(VTabsItems, {
    model: {
      value: _vm.indicators.destinations.tab,
      callback: function callback($$v) {
        _vm.$set(_vm.indicators.destinations, "tab", $$v);
      },
      expression: "indicators.destinations.tab"
    }
  }, [_c(VTabItem, {
    key: 1
  }, [_c("div", {
    ref: "chartDestinationsVolume",
    staticClass: "indicators-charts-item-chart"
  }), _vm.indicators.detailedView.isShown ? _c(VDataTable, {
    staticClass: "elevation-2 --background-transparent --no-shadow --border-1",
    attrs: {
      headers: _vm.indicators.detailedView.destinations.volume.headers,
      items: _vm.indicators.detailedView.destinations.volume.data,
      "hide-default-footer": ""
    }
  }) : _vm._e()], 1), _c(VTabItem, {
    key: 2
  }, [_c("div", {
    ref: "chartDestinationsOrders",
    staticClass: "indicators-charts-item-chart"
  }), _vm.indicators.detailedView.isShown ? _c(VDataTable, {
    staticClass: "elevation-2 --background-transparent --no-shadow --border-1",
    attrs: {
      headers: _vm.indicators.detailedView.destinations.orders.headers,
      items: _vm.indicators.detailedView.destinations.orders.data,
      "hide-default-footer": ""
    }
  }) : _vm._e()], 1), _vm.isShowTurnover ? _c(VTabItem, {
    key: 3
  }, [_c("div", {
    ref: "chartDestinationsTurnover",
    staticClass: "indicators-charts-item-chart"
  }), _vm.indicators.detailedView.isShown ? _c(VDataTable, {
    staticClass: "elevation-2 --background-transparent --no-shadow --border-1",
    attrs: {
      headers: _vm.indicators.detailedView.destinations.turnover.headers,
      items: _vm.indicators.detailedView.destinations.turnover.data,
      "hide-default-footer": ""
    }
  }) : _vm._e()], 1) : _vm._e()], 1)], 1), _c("div", {
    staticClass: "indicators-charts-item",
    class: {
      loaded: _vm.indicators.isLoaded
    }
  }, [_c("div", {
    staticClass: "indicators-charts-item-title"
  }, [_vm._v("Customer types")]), _c(VTabs, {
    attrs: {
      centered: ""
    },
    model: {
      value: _vm.indicators.customerTypes.tab,
      callback: function callback($$v) {
        _vm.$set(_vm.indicators.customerTypes, "tab", $$v);
      },
      expression: "indicators.customerTypes.tab"
    }
  }, [_c(VTab, {
    key: 1
  }, [_vm._v("Volume (btl)")]), _c(VTab, {
    key: 2
  }, [_vm._v("Orders")]), _vm.isShowTurnover ? _c(VTab, {
    key: 3
  }, [_vm._v("Turnover (€)")]) : _vm._e()], 1), _c(VTabsItems, {
    model: {
      value: _vm.indicators.customerTypes.tab,
      callback: function callback($$v) {
        _vm.$set(_vm.indicators.customerTypes, "tab", $$v);
      },
      expression: "indicators.customerTypes.tab"
    }
  }, [_c(VTabItem, {
    key: 1
  }, [_c("div", {
    ref: "chartCustomerTypesVolume",
    staticClass: "indicators-charts-item-chart"
  }), _vm.indicators.detailedView.isShown ? _c(VDataTable, {
    staticClass: "elevation-2 --background-transparent --no-shadow --border-1",
    attrs: {
      headers: _vm.indicators.detailedView.customerTypes.volume.headers,
      items: _vm.indicators.detailedView.customerTypes.volume.data,
      "hide-default-footer": ""
    }
  }) : _vm._e()], 1), _c(VTabItem, {
    key: 2
  }, [_c("div", {
    ref: "chartCustomerTypesOrders",
    staticClass: "indicators-charts-item-chart"
  }), _vm.indicators.detailedView.isShown ? _c(VDataTable, {
    staticClass: "elevation-2 --background-transparent --no-shadow --border-1",
    attrs: {
      headers: _vm.indicators.detailedView.customerTypes.orders.headers,
      items: _vm.indicators.detailedView.customerTypes.orders.data,
      "hide-default-footer": ""
    }
  }) : _vm._e()], 1), _vm.isShowTurnover ? _c(VTabItem, {
    key: 3
  }, [_c("div", {
    ref: "chartCustomerTypesTurnover",
    staticClass: "indicators-charts-item-chart"
  }), _vm.indicators.detailedView.isShown ? _c(VDataTable, {
    staticClass: "elevation-2 --background-transparent --no-shadow --border-1",
    attrs: {
      headers: _vm.indicators.detailedView.customerTypes.turnover.headers,
      items: _vm.indicators.detailedView.customerTypes.turnover.data,
      "hide-default-footer": ""
    }
  }) : _vm._e()], 1) : _vm._e()], 1)], 1)]), _c("div", {
    staticClass: "indicators-bigcharts"
  }, [_c("div", {
    staticClass: "indicators-bigcharts-item",
    class: {
      loaded: _vm.indicators.isLoaded
    }
  }, [_c("div", {
    staticClass: "indicators-bigcharts-item-title"
  }, [_vm._v(" References sold "), ((_this$indicators = this.indicators) === null || _this$indicators === void 0 || (_this$indicators = _this$indicators.data) === null || _this$indicators === void 0 || (_this$indicators = _this$indicators.indicatorsByReference) === null || _this$indicators === void 0 || (_this$indicators = _this$indicators.references) === null || _this$indicators === void 0 ? void 0 : _this$indicators.length) > _vm.NB_MAX_FOR_REFERENCE_CHARTS ? _c("span", {
    staticClass: "text-smaller-2 ml-2"
  }, [_vm._v(" (" + _vm._s(_vm.NB_MAX_FOR_REFERENCE_CHARTS) + " best) ")]) : _vm._e()]), _c(VTabs, {
    attrs: {
      centered: ""
    },
    model: {
      value: _vm.indicators.references.tab,
      callback: function callback($$v) {
        _vm.$set(_vm.indicators.references, "tab", $$v);
      },
      expression: "indicators.references.tab"
    }
  }, [_c(VTab, {
    key: 1
  }, [_vm._v("Volume (btl)")]), _c(VTab, {
    key: 2
  }, [_vm._v("Orders")]), _vm.isShowTurnover ? _c(VTab, {
    key: 3
  }, [_vm._v("Turnover (€)")]) : _vm._e()], 1), _c(VTabsItems, {
    model: {
      value: _vm.indicators.references.tab,
      callback: function callback($$v) {
        _vm.$set(_vm.indicators.references, "tab", $$v);
      },
      expression: "indicators.references.tab"
    }
  }, [_c(VTabItem, {
    key: 1
  }, [_c("div", {
    ref: "chartReferencesVolume",
    staticClass: "indicators-bigcharts-item-chart"
  }), _vm.indicators.detailedView.isShown ? _c(VDataTable, {
    staticClass: "elevation-2 --background-transparent --no-shadow --border-1",
    attrs: {
      headers: _vm.indicators.detailedView.references.volume.headers,
      items: _vm.indicators.detailedView.references.volume.data,
      "hide-default-footer": ""
    }
  }) : _vm._e()], 1), _c(VTabItem, {
    key: 2
  }, [_c("div", {
    ref: "chartReferencesOrders",
    staticClass: "indicators-bigcharts-item-chart"
  }), _vm.indicators.detailedView.isShown ? _c(VDataTable, {
    staticClass: "elevation-2 --background-transparent --no-shadow --border-1",
    attrs: {
      headers: _vm.indicators.detailedView.references.orders.headers,
      items: _vm.indicators.detailedView.references.orders.data,
      "hide-default-footer": ""
    }
  }) : _vm._e()], 1), _vm.isShowTurnover ? _c(VTabItem, {
    key: 3
  }, [_c("div", {
    ref: "chartReferencesTurnover",
    staticClass: "indicators-bigcharts-item-chart"
  }), _vm.indicators.detailedView.isShown ? _c(VDataTable, {
    staticClass: "elevation-2 --background-transparent --no-shadow --border-1",
    attrs: {
      headers: _vm.indicators.detailedView.references.turnover.headers,
      items: _vm.indicators.detailedView.references.turnover.data,
      "hide-default-footer": ""
    }
  }) : _vm._e()], 1) : _vm._e()], 1)], 1), _c("div", {
    staticClass: "indicators-bigcharts-item",
    class: {
      loaded: _vm.indicators.isLoaded
    }
  }, [_c("div", {
    staticClass: "indicators-bigcharts-item-title"
  }, [_vm._v("Customers")]), _vm.indicators.isLoaded && !!_vm.indicators.data.indicatorsByCustomer.customers ? _c("div", [_c(VDataTable, {
    staticClass: "--background-transparent cursor--pointer",
    attrs: {
      headers: _vm.indicators.customers.mainTableHeaders,
      items: _vm.indicators.data.indicatorsByCustomer.customers
    },
    on: {
      "click:row": _vm.showDetailsOfCustomer
    },
    scopedSlots: _vm._u([{
      key: "item.userGroupName",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c("div", {
          attrs: {
            title: item.user.userGroupName
          }
        }, [_vm._v(" " + _vm._s(item.user.userGroupName.substring(0, 3).toUpperCase()) + " ")])];
      }
    }, {
      key: "item.userMainAddress",
      fn: function fn(_ref2) {
        var _item$user$mainAddres;
        var item = _ref2.item;
        return [_c("div", [_vm._v(" " + _vm._s(item.user.mainAddress.country.name) + " " + _vm._s((_item$user$mainAddres = item.user.mainAddress.state) !== null && _item$user$mainAddres !== void 0 && _item$user$mainAddres.name ? ", ".concat(item.user.mainAddress.state.name) : "") + " ")])];
      }
    }, {
      key: "item.totalTurnoverExVatEuro",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_c("div", {
          staticClass: "text-bigger text-bold"
        }, [_vm._v(" " + _vm._s(_vm.formatPrice(item.totalTurnoverExVatEuro)) + " € ")])];
      }
    }, {
      key: "item.totalQuantity",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_c("div", {
          staticClass: "text-bigger text-bold"
        }, [_vm._v(_vm._s(item.totalQuantity))])];
      }
    }, {
      key: "item.nbOrders",
      fn: function fn(_ref5) {
        var item = _ref5.item;
        return [_c("div", {
          staticClass: "text-bigger text-bold"
        }, [_vm._v(_vm._s(item.nbOrders))])];
      }
    }, {
      key: "item.actions",
      fn: function fn(_ref6) {
        var item = _ref6.item;
        return [_c("div", {
          staticClass: "td-without-link --inline-actions no-print",
          on: {
            click: function click($event) {
              $event.stopPropagation();
            }
          }
        }, [_c("span", {
          staticClass: "dfwa-btn --small-2 secondary cursor--pointer --rounded",
          on: {
            click: function click($event) {
              return _vm.showDetailsOfCustomer(item);
            }
          }
        }, [_c(VIcon, {
          staticClass: "fas fa-plus mr-1",
          attrs: {
            size: "0.65rem"
          }
        }), _vm._v(" Details ")], 1)])];
      }
    }], null, true)
  })], 1) : _vm._e()]), !!_vm.indicators.customers.detailTable.items ? _c("div", {
    staticClass: "indicators-bigcharts-item",
    class: {
      loaded: _vm.indicators.isLoaded
    },
    attrs: {
      id: "detailsOfCustomerDiv"
    }
  }, [_c("div", {
    staticClass: "dialog-closer"
  }, [_c(VIcon, {
    staticClass: "far fa-times-circle",
    on: {
      click: function click($event) {
        return _vm.hideDetailsOfCustomer();
      }
    }
  })], 1), _c("div", {
    staticClass: "indicators-bigcharts-item-title"
  }, [_vm._v(" " + _vm._s(_vm.indicators.customers.detailTable.title) + " ")]), _c("div", [_c(VDataTable, {
    staticClass: "--background-transparent",
    attrs: {
      headers: _vm.indicators.customers.detailTable.headers,
      items: _vm.indicators.customers.detailTable.items,
      "hide-default-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "item.wineCogs",
      fn: function fn(_ref7) {
        var item = _ref7.item;
        return [_c("div", [_vm._v(_vm._s(_vm.formatPrice(item.wine.instantCogsEuro)) + " €")])];
      }
    }, {
      key: "item.averageUnitSalePriceExVatEuro",
      fn: function fn(_ref8) {
        var item = _ref8.item;
        return [_c("div", [_vm._v(_vm._s(_vm.formatPrice(item.averageUnitSalePriceExVatEuro)) + " €")])];
      }
    }, {
      key: "item.averageUnitSalePriceExVatEuroIncludeShipping",
      fn: function fn(_ref9) {
        var item = _ref9.item;
        return [_c("div", [_vm._v(_vm._s(_vm.formatPrice(item.averageUnitSalePriceExVatEuroIncludeShipping)) + " €")])];
      }
    }, {
      key: "item.totalTurnoverExVatEuro",
      fn: function fn(_ref10) {
        var item = _ref10.item;
        return [_c("div", {
          staticClass: "text-bigger text-bold"
        }, [_vm._v(" " + _vm._s(_vm.formatPrice(item.totalTurnoverExVatEuro)) + " € ")])];
      }
    }, {
      key: "item.totalQuantity",
      fn: function fn(_ref11) {
        var item = _ref11.item;
        return [_c("div", {
          staticClass: "text-bigger text-bold"
        }, [_vm._v(_vm._s(item.totalQuantity))])];
      }
    }, {
      key: "item.nbOrders",
      fn: function fn(_ref12) {
        var item = _ref12.item;
        return [_c("div", {
          staticClass: "text-bigger text-bold"
        }, [_vm._v(_vm._s(item.nbOrders))])];
      }
    }], null, true)
  })], 1)]) : _vm._e()])])]], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };